import { render, staticRenderFns } from "./StockDelivered.vue?vue&type=template&id=a6779fb6&scoped=true&"
import script from "./StockDelivered.vue?vue&type=script&lang=js&"
export * from "./StockDelivered.vue?vue&type=script&lang=js&"
import style0 from "./StockDelivered.vue?vue&type=style&index=0&id=a6779fb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6779fb6",
  null
  
)

export default component.exports